import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 40px;
`;

export const Divider = styled.div`
  width: 100%;
  border-bottom: solid 1px #d3d3d3;
  position: relative;
  margin-top: 12px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 47%;
`;

export const ClaimsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const OnelineCell = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CenteredCell = styled.div`
  justify-self: center;
`;

export const InputHeader = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
`;

export const NewFlagInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

export const InputWrapper = styled.div`
  width: 140px;
  margin-right: 10px;
`;

export const InputRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const InputLabel = styled.div`
  font-size: 16px;
  max-width: 90px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  font-size: 16px;
  max-width: 165px;
  overflow-wrap: anywhere;
`;

export const GenerateButtonWrapper = styled.div`
  height: 40px;
`;

export const AddButtonWrapper = styled.div`
  height: 34px;
`;

export const DeleteButton = styled.div`
  :hover {
    color: red;
    cursor: pointer;
  }
`;
